import React, { useState } from 'react'
import { connect } from 'react-redux'
import { removeBackupEmail } from '../../actions/user'
import { dismissEmailVerificationPrompt } from '../../actions/emailVerification'
import { hideModal } from '../../actions/modals'
import { showNotification } from '../../actions/notifications'
import ReauthenticationModal from '../../components/reauthenticationModal/ReauthenticationModal'
import EmailVerificationButtonLabel from '../../components/modals/emailVerification/EmailVerificationButtonLabel'
import handleAccountRequest from './utils/handleAccountRequest'

function RemoveBackupEmailContainer(props) {
  const {
    hideModal,
    showNotification,
    removeBackupEmail,
    dismissEmailVerificationPrompt,
    user,
    signinMethods,
  } = props
  const [showReauthenticationModal, setShowReauthenticationModal] = useState(false)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)

  function onAuthenticate(authentication) {
    handleAccountRequest({
      setSubmitLoading,
      setErrorMessage,
      // { type: 'password', password } or { type: 'google' | 'apple', idToken }
      // — the endpoint accepts either, same as the backup-email create
      makeRequest: () => removeBackupEmail(user.id, authentication).then((response) => {
        // suppress the "add a backup email" nag from popping back up right
        // after the user just deliberately removed theirs
        dismissEmailVerificationPrompt(user.id, 'addBackup').catch(() => {})
        return response
      }),
      hideModal,
      showSuccessNotification: () => showNotification('Backup Email', 'Removed', 'default'),
      requestName: 'removeBackupEmail',
    })
  }

  return (
    <div className='emailVerificationFlow-backupOffer'>
      <div className='emailVerificationFlow-title'>Remove backup email address</div>
      <div className='emailVerificationFlow-description'>
        Please confirm that you would like to remove your backup email address.
      </div>
      <div className='emailVerificationFlow-emailBox'>
        <div className='emailVerificationFlow-emailBox-label'>Backup Email</div>
        <div className='emailVerificationFlow-emailDisplay'>{user.backupEmail}</div>
      </div>
      {errorMessage && (
        <div className='emailVerificationFlow-error'>{errorMessage}</div>
      )}
      <button
        type='button'
        className={`btn btn--blue btn--large${submitLoading ? ' btn--disabled' : ''}`}
        onClick={() => setShowReauthenticationModal(true)}
        disabled={submitLoading}
      >
        <EmailVerificationButtonLabel label='Confirm' loading={submitLoading} />
      </button>
      <div className='emailVerificationFlow-form-links'>
        <button type='button' className='emailVerificationFlow-linkBtn' onClick={hideModal}>
          Cancel
        </button>
      </div>

      {showReauthenticationModal && (
        <ReauthenticationModal
          title='Remove Backup Email'
          signinMethodsToDisplay={signinMethods}
          onAuthenticate={(authentication) => onAuthenticate(authentication)}
          hideModal={() => setShowReauthenticationModal(false)}
        />
      )}
    </div>
  )
}

export default connect(
  (state) => ({
    user: state.user,
    signinMethods: state.signinMethods,
  }),
  {
    removeBackupEmail,
    dismissEmailVerificationPrompt,
    hideModal,
    showNotification,
  },
)(RemoveBackupEmailContainer)
